import { Link, useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';

import { userAtom } from '../../services/atoms/auth.atoms';
import { ROUTES } from '../../helpers/constants';
import { BurgerButton } from '../buttons/burger-button';
import { SidebarMenuCard } from '../../types/types';

import GrowmeLogo from '../../assets/growme-logo.svg';
import GrowmeName from '../../assets/growme-name-logo.svg';

interface props {
  toggle: () => void;
  card: SidebarMenuCard;
}

export const NavbarMenu: React.FC<props> = ({ toggle }) => {
  let navigate = useNavigate();
  const userData = useRecoilValue(userAtom);
  return (
    <div id='navbar' className="gm-navbar-menu-container">
      <div className='gm-navbar-actions-container'>
        <BurgerButton toggle={toggle} />
        <div className='gm-navbar-logo-container' onClick={() => navigate(ROUTES.CLIENTS.route)} >
          <img src={GrowmeLogo} alt='growme-logo' />
          <img src={GrowmeName} alt='growme-name-logo' />
        </div>
      </div>
      <div className='gm-navbar-profile-container'>
        <img className="gm-navbar-profile-image" src='https://cdn-icons-png.flaticon.com/512/149/149071.png' alt='gm-profile-img' />
        <div className='gm-navbar-profile-data'>
          <span className='gm-navbar-profile-name'>{userData.data.displayName}</span>
          <span className='gm-navbar-profile-email'>{userData.data.email}</span>
        </div>
      </div>
    </div>
  );
}